import { CONFIRM_GAME_REPORT_REFEREE, OVERWRITE_GAME_REPORT_REFEREE, SAVE_GAME_REPORT_REFEREE_DRAFT, SIGN_GAME_REPORT_REFEREE } from '../constants/actionTypes';

export const confirmGameReportReferee = ( context, token, gameId, gameReportReferee, username ) => {

    return {
        type:    CONFIRM_GAME_REPORT_REFEREE,
        payload: { context, token, gameId, gameReportReferee, username }
    };

};

export const overwriteGameReportReferee = ( context, token, gameId, gameReportReferee ) => {

    return {
        type:    OVERWRITE_GAME_REPORT_REFEREE,
        payload: { context, token, gameId, gameReportReferee }
    };

};

export const saveGameReportRefereeDraft = ( context, token, gameId, gameReportReferee ) => {

    return {
        type:    SAVE_GAME_REPORT_REFEREE_DRAFT,
        payload: { context, token, gameId, gameReportReferee }
    };

};

export const signGameReportReferee = ( context, token, gameId, team, comment, name, username ) => {

    return {
        type:    SIGN_GAME_REPORT_REFEREE,
        payload: { context, token, gameId, team, comment, name, username }
    };

};